import {Component, ContentChildren, Input, OnInit, QueryList, TemplateRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {IccdFomrIddDirective} from '@atmi/shared/card-manager/iccd-manager/iccd-form-id.directive';

import {BaseCtrlValueAccessorFormComponent} from '@sim/form';
import {ClassName} from '@sim/role';
import {projectToMap} from '@ui/ui.module';

@Component({
  selector: 'app-iccd-manager',
  styleUrls: ['./iccd-manager.component.scss'],
  templateUrl: './iccd-manager.component.html',
})
export class IccdManagerComponent extends BaseCtrlValueAccessorFormComponent<any> implements OnInit {

  @Input() classNames: ClassName[] = [];

  @Input() isOperaMadre = false;

  iccdTemplate?: Record<string, TemplateRef<any>>;

  @ContentChildren(IccdFomrIddDirective) set iccdTemplateRefs(list: QueryList<IccdFomrIddDirective>) {
    const templates = list.toArray();
    this.iccdTemplate = projectToMap(templates, 'id', (x) => x.templateRef);
  }

  get iccdQueryParams(): string[] {
    const iccd = this.route.snapshot.queryParams.iccd;
    return iccd ? iccd.split(',') : [];
  }

  constructor(
    private readonly route: ActivatedRoute,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.form?.markAllAsTouched();
    this.form?.updateValueAndValidity();
  }

  trackByGroupName(_: number, group: { name: string }) {
    return group.name;
  }
}
